<template>
  <v-layout row wrap>
    <v-container grid-list-xl>
      <v-layout>
        <v-flex>
          <v-card color="secondary">
            <v-card-text>
              Firmware Versies 30 Dagen
              <GChart type="BarChart"
                      :data="clientData"
                      :options="barChartOptions" />
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex>
          <v-card color="secondary">
            <v-card-text>
              Componenten 30 Dagen
              <GChart type="PieChart"
                      :data="componentData"
                      :options="chartOptions" />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-data-table :headers="headers"
                    :items="analytics"
                    :pagination.sync="pagination"
                    class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr :class="{'error': props.item.isError}">
            <td class="text-xs-left" style="width:30px;">{{ props.item.id }}</td>
            <td class="text-xs-left" style="width:150px;">{{ formatDateTime(props.item.timestamp) }}</td>
            <td class="text-xs-left" style="width:30px;">{{ props.item.deviceId }}</td>
            <td class="text-xs-left" style="width:30px;">{{ props.item.component }}</td>
            <td class="text-xs-left" style="width:30px;">{{ props.item.action }}</td>
            <td class="text-xs-left" style="max-width:150px;">{{ props.item.result }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
  import { GChart } from 'vue-google-charts'
  export default {
    name: 'Analytics',
    components: {
      GChart
    },
    data() {
      return {
        analytics: [],
        headers: [
          { text: 'Id', value: 'id' },
          { text: 'Datum', value: 'timestamp' },
          { text: 'Apparaat', value: 'deviceId' },
          { text: 'Component', value: 'component' },
          { text: 'Actie', value: 'action' },
          { text: 'Result / Boodschap', value: 'result' }
        ],
        pagination: {
          rowsPerPage: 25,
          descending: true,
          sortBy: "timestamp"
        },
        firmwareVersions: [],
        analyticComponents: [],
        firmwareVersionHeader: ['Version', 'iMatches'],
        componentDataHeader: ['Component', 'iMatches'],
        chartOptions: {
          backgroundColor: 'none',
          titleTextStyle: { color: 'white' },
          legend: { textStyle: { color: 'white' } },
          width: 400,
          is3D: true
        },
        barChartOptions: {
          backgroundColor: 'none',
          titleTextStyle: { color: 'white' },
          vAxis: { textStyle: { color: 'white' } },
          hAxis: { textStyle: { color: 'white' } },
          width: 400,
          legend: { position: "none" },
        }
      }
    },
    computed: {
      clientData() {
        return [this.firmwareVersionHeader, ...this.firmwareVersions]
      },
      componentData() {
        return [this.componentDataHeader, ...this.analyticComponents]
      }
    },
    methods: {
      formatDateTime(date) {
        return this.$moment(date).format('DD-MM-YYYY hh:mm')
      },
      getData() {
        this.$http.get('api/analytics/')
          .then(request => {
            this.analytics = request.data
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */,
        this.$http.get('api/analytics/firmwareversions/30')
          .then(request => {
            var versions = request.data
            var result = Object.keys(versions).map(function (key) {
              var name = versions[key].version.substring(1, 12);
              if (name.substring(name.length - 1) == "-") name = name.substring(0, name.length - 1)
              if (versions[key].version.indexOf("dirty") > 0) name += "d"
              return [name, versions[key].count]
            });
            this.firmwareVersions = result
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */,
        this.$http.get('api/analytics/components/30')
          .then(request => {
            var clients = request.data
            var result = Object.keys(clients).map(function (key) {
              return [clients[key].component, clients[key].count]
            });
            this.analyticComponents = result
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */
      },
      deleteAnalytics(analytic) {
        this.$http.delete('api/analytics/' + analytic.id)
          .then(() => {
            this.analytics.splice(this.analytics.indexOf(analytic), 1)
          })
          .catch((err) => { console.log(err) }) /* eslint-disable-line no-console */
      }
    },
    mounted() {
      this.getData()
    }
  }
</script>
